document.addEventListener('alpine:init', () => {
  Alpine.store('product', {
    products_viewed_ids: Alpine.$persist('').as('_x_products_viewed_ids'),
    getRecentlyViewedIds(){
        let product_ids = [];
        if (this.products_viewed_ids != undefined) {
          product_ids = this.products_viewed_ids.split(',');
          if (product_ids.length == 1 && product_ids[0] == '') {
            product_ids = [];
          }
        }
        return product_ids;
    },
    view(product_id) {
      // json serialize products_viewed_ids to list first
      // check if is in products_viewed_ids
      // if not insert to front
      // if yes, shift it to the front
      // if length exceed 16, remove the last one
      const product_ids = this.getRecentlyViewedIds();
      const index = product_ids.indexOf(product_id.toString());
      if (index !== -1) {
        product_ids.splice(index, 1);
      }
      product_ids.unshift(product_id.toString());
      if (product_ids.length > 16) {
        product_ids.pop();
      }
      this.products_viewed_ids = product_ids.join(',');
    },
  });
});
